import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { GradeEntity } from "../../services/grade/grade.types";

export type GradeState = {
  grades: GradeEntity[];
  loading: boolean;
};

const initialState: GradeState = {
  grades: [],
  loading: false,
};

const grade = createSlice({
  name: "grade",
  initialState,
  reducers: {
    clearGrade: (state) => {
      state.grades = [];
      state.loading = false;
    },
    setLoading: (state, action: PayloadAction<boolean>) => {
      state.loading = action.payload;
    },
    setGrades: (state, action: PayloadAction<GradeEntity[]>) => {
      state.grades = action.payload;
      state.loading = false;
    },
    addGrade: (state, action: PayloadAction<GradeEntity>) => {
      state.grades.unshift(action.payload);
    },
    updateGrade: (
      state,
      action: PayloadAction<{ id: number; data: GradeEntity }>
    ) => {
      const index = state.grades.findIndex(
        (grade) => grade.id === action.payload.id
      );
      if (index !== -1) {
        state.grades[index] = action.payload.data;
      }
    },
    deleteGrade: (state, action: PayloadAction<number>) => {
      state.grades = state.grades.filter(
        (grades) => grades.id !== action.payload
      );
    },
  },
});

export default grade;
export const {
  addGrade,
  clearGrade,
  deleteGrade,
  setGrades,
  setLoading,
  updateGrade,
} = grade.actions;
